export const goToInitialPage = (navigate) => {
  navigate('/')
};

export const goToLogin = (navigate) => {
  navigate('/login')
} 

export const goToHome = (navigate) => {
  navigate('/home')
} 